import PropTypes from 'prop-types'
import { DetailsContainer as Container } from '@calendly/booking-kit'
import styled from 'astroturf/react'
import _StyledDetails from "index-StyledDetails.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/details/index.js?styleId=StyledDetails";

const colorStrokeMedium = 'var(--colorStrokeMedium, var(--coreColorNeutral500))'

const StyledDetails = /*#__PURE__*/styled('div', null, {
  displayName: "StyledDetails",
  styles: _StyledDetails
})

const Details = ({ flow = 'column', bookingAppRedesign = false, ...props }) => (
  <StyledDetails bookingAppRedesign={bookingAppRedesign}>
    <Container data-container="details" flow={flow} bookingAppRedesign={bookingAppRedesign} {...props} />
  </StyledDetails>
)

Details.propTypes = {
  flow: PropTypes.oneOf(['column', 'row']),
  bookingAppRedesign: PropTypes.bool
}

export default Details
